import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypePersonSkeleton } from "./TypePerson";
import type { TypeTableOfContentsSettingSkeleton } from "./TypeTableOfContentsSetting";

/**
 * Fields type definition for content type 'TypePersonsSection'
 * @name TypePersonsSectionFields
 * @type {TypePersonsSectionFields}
 * @memberof TypePersonsSection
 */
export interface TypePersonsSectionFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'header' (Header)
     * @name Header
     * @localized false
     */
    header?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'subHeader' (Sub Header)
     * @name Sub Header
     * @localized false
     */
    subHeader?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'persons' (Persons)
     * @name Persons
     * @localized false
     */
    persons: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypePersonSkeleton>>;
    /**
     * Field type definition for field 'backgroundColor' (Background Color)
     * @name Background Color
     * @localized false
     */
    backgroundColor?: EntryFieldTypes.Symbol<"grey" | "light-blue" | "white">;
    /**
     * Field type definition for field 'tocSetting' (tocSetting)
     * @name tocSetting
     * @localized false
     */
    tocSetting?: EntryFieldTypes.EntryLink<TypeTableOfContentsSettingSkeleton>;
}

/**
 * Entry skeleton type definition for content type 'personsSection' (Persons Section)
 * @name TypePersonsSectionSkeleton
 * @type {TypePersonsSectionSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T00:39:07.590Z
 * @version 9
 */
export type TypePersonsSectionSkeleton = EntrySkeletonType<TypePersonsSectionFields, "personsSection">;
/**
 * Entry type definition for content type 'personsSection' (Persons Section)
 * @name TypePersonsSection
 * @type {TypePersonsSection}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T00:39:07.590Z
 * @version 9
 */
export type TypePersonsSection<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypePersonsSectionSkeleton, Modifiers, Locales>;

export function isTypePersonsSection<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypePersonsSection<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'personsSection'
}
